/**
 * Central registry for every key the app writes to `window.localStorage`.
 *
 * Why one file:
 *   - Catches accidental key collisions at code-review time.
 *   - The `StorageKey` union forces `localStorageUtil` callers to pass a
 *     known key — no stringly-typed reads scattered across the codebase.
 *
 * Naming: prefix every key with `ps_` so we can see what's ours in DevTools
 * and don't collide with third-party scripts.
 */

export const STORAGE_KEYS = {
    SESSION:    'ps_session',
    AUTH_TOKEN: 'ps_auth_token',
    PLAN:       'ps_plan',
    ACCESS:     'ps_access',
    /** Every account this browser is signed in to — see utils/account-book. */
    ACCOUNTS:   'ps_accounts',
    COMPARE:    'ps_compare',
    FAVORITES:  'ps_favorites',
    /** Super-admin: ids of activity-feed events already seen. */
    ADMIN_READ_EVENTS: 'ps_admin_read_events',
    /** Super-admin: help articles / videos / what's-new shown in the Help panel. */
    HELP_CONTENT:      'ps_help_content',
    /** Sidebar collapsed to the icon rail — a per-browser UI preference. */
    SIDEBAR_COLLAPSED: 'ps_sidebar_collapsed',
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];
